import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=035d6e3a&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=035d6e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d6e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035d6e3a')) {
      api.createRecord('035d6e3a', component.options)
    } else {
      api.reload('035d6e3a', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=035d6e3a&scoped=true&", function () {
      api.rerender('035d6e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/Edit.vue"
export default component.exports